/**
 * Identifying which payment method type is selected.
 */
export const getSelectedPaymentMethod = (paymentMethodType?: string) => {
  const isGooglePay = paymentMethodType === GOOGLE_PAY;
  const isApplePay = paymentMethodType === APPLE_PAY;
  const isLink = paymentMethodType === LINK;
  const isCashApp = paymentMethodType === CASH_APP;

  return {
    isGooglePay,
    isApplePay,
    isLink,
    isCashApp,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GOOGLE_PAY = 'Google Pay';
const APPLE_PAY = 'Apple Pay';
const LINK = 'Link';
const CASH_APP = 'Cash App';
